import type { TranslationTag, Values } from '@ps/web-core-intl';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import CurrencyAmount from '@swf/components/CurrencyAmount/CurrencyAmount';
import FormattedTimeZone from '@swf/components/FormattedTimeZone/FormattedTimeZone';
import useWizardContext from '@swf/core/hooks/useWizardContext';

import type { PreCashinInfo } from '../../../../../../../../../types/Cashier';

import {
  TXTCLI_You_can_make_N0_depositsX_incl_ELL,
  TXTCLI_You_can_make_Xb_classXXredXXN2_ELL,
  TXTCLI_You_can_make_Xb_classXXredXXN3_ELL
} from './DefaultDeposits.messages.json';

const DefaultDeposits: React.FC = () => {
  const {
    data: { preCashinInfo }
  } = useWizardContext();

  const {
    bonusMax,
    bonusEnd,
    bonusPercent,
    bonusCurrency,
    maxNumberOfDeposits,
    lastAllowedDepositTime,
    maxNumberOfDepositsLeft,
    maxDaysForDepositLeft
  } = preCashinInfo as PreCashinInfo;
  const bonusMaxFormatted = <CurrencyAmount value={bonusMax} currency={bonusCurrency} />;
  const formattedDate = (
    <FormattedTimeZone
      date={lastAllowedDepositTime || bonusEnd}
      month="short"
      day="2-digit"
      year="numeric"
      hour="numeric"
      minute="numeric"
      timeZoneName="short"
      hour12={false}
    />
  );

  let translation: TranslationTag;
  let values: Values;

  if (maxDaysForDepositLeft) {
    if (maxNumberOfDeposits === maxNumberOfDepositsLeft) {
      translation = TXTCLI_You_can_make_N0_depositsX_incl_ELL;
      values = {
        0: maxNumberOfDepositsLeft,
        1: maxDaysForDepositLeft,
        2: formattedDate
      };
    } else {
      translation = TXTCLI_You_can_make_N0_depositsX_incl_ELL;
      values = {
        0: maxNumberOfDepositsLeft,
        1: maxDaysForDepositLeft,
        2: bonusPercent,
        3: bonusMaxFormatted
      };
    }
  } else {
    if (!lastAllowedDepositTime) {
      translation = TXTCLI_You_can_make_Xb_classXXredXXN2_ELL;
      values = {
        0: bonusMaxFormatted,
        1: bonusPercent,
        2: maxNumberOfDepositsLeft
      };
    } else {
      translation = TXTCLI_You_can_make_Xb_classXXredXXN3_ELL;
      values = {
        0: bonusMaxFormatted,
        1: bonusPercent,
        2: formattedDate,
        3: maxNumberOfDepositsLeft
      };
    }
  }

  return <Translation tagName="p" {...translation} values={{ ...values }} />;
};

export default DefaultDeposits;
